export const SCHOOL_DROPOUT_REASON_DROPOUT_ABANDONMENT = '1'
export const SCHOOL_DROPOUT_REASON_DROPOUT_DOUBLING = '2'
export const SCHOOL_DROPOUT_REASON_DROPOUT_SOCIAL = '3'
export const SCHOOL_DROPOUT_REASON_DROPOUT_FINANCIAL = '4'
export const SCHOOL_DROPOUT_REASON_DROPOUT_HEALTH = '5'
export const SCHOOL_DROPOUT_REASON_DROPOUT_VIOLENCE = '6'
export const SCHOOL_DROPOUT_REASON_DROPOUT_OTHER = '7'

export const REASON_DROPOUT = {
  [SCHOOL_DROPOUT_REASON_DROPOUT_ABANDONMENT]: "SCHOOL_DROPOUT.REASON_DROPOUT.ABANDONMENT",
  [SCHOOL_DROPOUT_REASON_DROPOUT_DOUBLING]: "SCHOOL_DROPOUT.REASON_DROPOUT.DOUBLING",
  [SCHOOL_DROPOUT_REASON_DROPOUT_SOCIAL]: "SCHOOL_DROPOUT.REASON_DROPOUT.SOCIAL" ,
  [SCHOOL_DROPOUT_REASON_DROPOUT_FINANCIAL]: "SCHOOL_DROPOUT.REASON_DROPOUT.FINANCIAL",
  [SCHOOL_DROPOUT_REASON_DROPOUT_HEALTH]: "SCHOOL_DROPOUT.REASON_DROPOUT.HEALTH",
  [SCHOOL_DROPOUT_REASON_DROPOUT_VIOLENCE]: "SCHOOL_DROPOUT.REASON_DROPOUT.VIOLENCE",
  [SCHOOL_DROPOUT_REASON_DROPOUT_OTHER]: "SCHOOL_DROPOUT.REASON_DROPOUT.OTHER",
}

export const schoolDropoutReasonDropoutUIHelper = (intl) =>
  Object.keys(REASON_DROPOUT).map((key) => ({
    value: key,
    label: intl.formatMessage({ id: REASON_DROPOUT[key] }),
  }))
